/// <amd-module name="Artifacts/Cargo/components/Logo" />
import * as CargoRes from "Artifacts/Cargo/Resources";
import { ILogoProps } from "Artifacts/Package/types/ILogoProps";
import * as React from "react";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Image } from "VSSUI/Image";

export const logoContributionId = "ms.azure-artifacts.protocol-cargo.logo";

const Logo: React.FC<ILogoProps> = ({ className }) => {
  const { pageContext } = useComponentContext();

  return (
    <Image
      className={className}
      alt={CargoRes.Logo_Cargo}
      src={getAssetLocation(pageContext, "ms.azure-artifacts/protocol-cargo/img/rust.svg")}
    />
  );
};

Components.add(logoContributionId, Logo);

export { Logo };
